import { CorreoArgentinoAgency } from './types';

type AgencyHours = CorreoArgentinoAgency['hours'];

const formatTimeString = (time: string): string => {
  if (!time || time.length < 4) return time;
  return `${time.substring(0, 2)}:${time.substring(2)}`;
};

export function formatAgencyHours(hours: AgencyHours | undefined | null): string {
  if (!hours) return '';

  const allDays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'] as const;
  const weekdays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'] as const;

  const firstOpenDay = allDays.find(day => hours[day] !== null);

  if (!firstOpenDay || !hours[firstOpenDay]) return '';

  const h = hours[firstOpenDay];
  const startFormatted = formatTimeString(h.start);
  const endFormatted = formatTimeString(h.end);

  const hasWeekdayOpen = weekdays.some(day => hours[day] !== null);
  const hasSaturday = hours.saturday !== null;
  const hasSunday = hours.sunday !== null;

  if (!hasWeekdayOpen && hasSaturday && !hasSunday) {
    return `Sáb ${startFormatted} - ${endFormatted}`;
  }

  if (!hasWeekdayOpen && hasSaturday && hasSunday) {
    return `Sáb y Dom ${startFormatted} - ${endFormatted}`;
  }

  if (!hasWeekdayOpen && !hasSaturday && hasSunday) {
    return `Dom ${startFormatted} - ${endFormatted}`;
  }

  if (hasSaturday && hasSunday) {
    return `Lun a Dom ${startFormatted} - ${endFormatted}`;
  }

  if (hasSaturday) {
    return `Lun a Sáb ${startFormatted} - ${endFormatted}`;
  }

  return `Lun a Vie ${startFormatted} - ${endFormatted}`;
}
